<template>
<div :id="'multiple-choice-v1-c6z4l0' + '-' + id">
    <b-form-group :id="'multiple-choice-v1-yfqiz7' + '-' + id" v-if="showType == 'form-builder'" :description="properties.description" :label="properties.label" :style="properties.style">
      <b-form-checkbox-group :id="'multiple-choice-v1-v0rf3n' + '-' + id" :stacked="!properties.showInline">
        <b-row :id="'multiple-choice-v1-5ayd4u' + '-' + id">
          <b-col v-for="(column, columnIndex) in fBOptionColumns" :key="columnIndex" :id="'multiple-choice-v1-xzzqcn-' + columnIndex + '-' + id">
            <b-form-checkbox :value="option" :key="optionIndex" :class="properties.showInline ? 'mr-2' : ''" v-for="(option, optionIndex) in column" :id="'multiple-choice-v1-dp9050-' + columnIndex + '-' + optionIndex + '-' + id">{{ option }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
    <div :id="'multiple-choice-v1-jlf6yg' + '-' + id" v-if="showType == 'properties'">
      <multiple-choice-v1-properties :id="'multiple-choice-v1-znlu3p' + '-' + id" :formId="formId"></multiple-choice-v1-properties>
    </div>
    <b-form-group :id="'multiple-choice-v1-ithz3y' + '-' + id" style="font-size: 14px" v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      " :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      " :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      " :style="properties.style" :hidden="computedHidden" :state="state" :invalid-feedback="errors.join(', ')">
      <b-form-checkbox-group :id="'multiple-choice-v1-gxsukb' + '-' + id" v-model="controlValue" :stacked="!properties.showInline">
        <b-row :id="'multiple-choice-v1-o99l54' + '-' + id">
          <b-col v-for="(column, columnIndex) in optionColumns" :key="columnIndex" :id="'multiple-choice-v1-y7ewmg-' + columnIndex + '-' + id">
            <b-form-checkbox style="font-size: 14px" :value="option" :key="optionIndex" :class="properties.showInline ? 'mr-2' : ''" v-for="(option, optionIndex) in column" :id="'multiple-choice-v1-2yvb9t-' + columnIndex + '-' + optionIndex + '-' + id">{{ option }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
    <b-form-group :id="'multiple-choice-v1-o97qnt' + '-' + id" v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      " :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      ">
      <b-row :id="'multiple-choice-v1-o8mjrc' + '-' + id">
        <b-col v-for="(column, columnIndex) in optionColumns" :key="columnIndex" :id="'multiple-choice-v1-1okjy3-' + columnIndex + '-' + id">
          <div :class="properties.showInline ? 'd-flex flex-row flex-wrap' : ''" :id="'multiple-choice-v1-0gwfu0-' + columnIndex + '-' + id">
            <div :value="option" :key="optionIndex" v-for="(option, optionIndex) in column" class="mr-2" :id="'multiple-choice-v1-7o76ks-' + columnIndex + '-' + optionIndex + '-' + id">
              <b-icon-check-square-fill class="text-primary" v-if="controlValue.indexOf(option) >= 0" :id="'multiple-choice-v1-yq8k9d-' + columnIndex + '-' + optionIndex + '-' + id"></b-icon-check-square-fill><b-icon-square v-else :id="'multiple-choice-v1-l8mrjw-' + columnIndex + '-' + optionIndex"></b-icon-square> {{ option }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form-group>
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import { chunkColumns } from "../../../../helpers/general";
import MultipleChoiceV1Properties from "./MultipleChoiceV1Properties.vue";
import collectionServer from "../../../../server/collection";
import { getComponentBaseId } from "../../../../helpers/formBuilder";
export default {
  name: "MultipleChoiceV1",
  components: { MultipleChoiceV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {},
      fBOptions: []
    };
  },
  mounted() {
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      const baseId = getComponentBaseId(this.id);
      this.setFormSubmitterComponentMetadata({
        controlId: baseId,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: baseId,
          properties: this.properties
        });
      }
    }
    this.getFBOptions();

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async getFBOptions() {
      if (typeof this.properties.options == "string") {
        let re = /\{\{collections.(?:(?!\}\}).)*\}\}/g;
        const matches = [...this.properties.options.matchAll(re)];
        if (
          matches.length == 1 &&
          this.properties.options.startsWith("{{") &&
          this.properties.options.endsWith("}}")
        ) {
          const collections = await collectionServer.query();
          const collection = collections.find(
            c =>
              c.name ==
              this.properties.options.slice(
                14,
                this.properties.options.length - 2
              )
          );
          this.fBOptions = collection.data.items;
        } else this.fBOptions = this.properties.options;
      } else this.fBOptions = this.properties.options;
    },
   getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div class="row">
            ${this.fBOptionColumns
              .map(
                column => `
            <div class="col">
              <div class="${
                this.properties.showInline ? "d-flex flex-row flex-wrap" : ""
              }">
                ${column
                  .map(
                    option => `
                  <div style="font-size: 14px" class="mr-2">
                    ${
                      this.controlValue?.indexOf(option) >= 0
                        ? '<i class="fas fa-check-square text-primary"></i>'
                        : '<i class="far fa-square"></i>'
                    } ${option} </div>
                `
                  )
                  .join("")}
              </div>
            </div>
            `
              )
              .join("")}
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        const baseId = getComponentBaseId(this.id);
        const multipleChoiceValue = this.results 
          ? this.results[baseId] 
          : this.getFormSubmitterComponentValue(baseId);

        if(typeof multipleChoiceValue === "string") {
          return multipleChoiceValue !== "" ? [multipleChoiceValue] : [];
        }
        
        return multipleChoiceValue;        
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const baseId = getComponentBaseId(this.id);
          this.setFormSubmitterComponentValue({
            controlId: baseId,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: baseId,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        const errorId = getComponentBaseId(this.id, this.formErrors);
        return this.formErrors[errorId] ? this.formErrors[errorId] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    fBOptionColumns() {
      const options = this.fBOptions;

      return chunkColumns(options, this.properties.columnsCount);
    },
    optionColumns() {
      const options = this.computedConditions.options
        ? this.computedPropertiesForm.options
        : this.properties.options;

      return chunkColumns(options, this.properties.columnsCount);
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    "properties.options": function() {
      if (this.showType == "form-builder") this.getFBOptions();
    }
  }
};
</script>
